import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuard } from 'src/app/authGuardClass';
import { ComponentsService } from 'src/app/components.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    @ViewChild('password') passRef: ElementRef;
    @ViewChild('username') userRef: ElementRef;

    constructor(
        private authGuard: AuthGuard,
        private router: Router,
        private service: ComponentsService
    ) {}

    ngOnInit(): void {}

    errMessage: any;
    displayErrMessage: boolean = false;

    username: String = '';
    password: String = '';

    logIn(e) {
        e.preventDefault();
        let data = {
            username: this.userRef.nativeElement.value,
            password: this.passRef.nativeElement.value
        };
        this.authGuard.logIn(data).then((data: any) => {
            if (data.success == true) {
                this.service.setUsersPerm(data.user);
                this.router.navigate(['/home']);
            } else {
                this.errMessage = data.message;
                this.displayErrMessage = true;
            }
        });
    }
}
